/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Detail_Export_PdfInputs */

const en_cover_letters_detail_export_pdf = /** @type {(inputs: Cover_Letters_Detail_Export_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export PDF`)
};

const de_cover_letters_detail_export_pdf = /** @type {(inputs: Cover_Letters_Detail_Export_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF exportieren`)
};

const fr_cover_letters_detail_export_pdf = /** @type {(inputs: Cover_Letters_Detail_Export_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter en PDF`)
};

const es_cover_letters_detail_export_pdf = /** @type {(inputs: Cover_Letters_Detail_Export_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar PDF`)
};

const it_cover_letters_detail_export_pdf = /** @type {(inputs: Cover_Letters_Detail_Export_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta PDF`)
};

const nl_cover_letters_detail_export_pdf = /** @type {(inputs: Cover_Letters_Detail_Export_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporteer PDF`)
};

const pl_cover_letters_detail_export_pdf = /** @type {(inputs: Cover_Letters_Detail_Export_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksportuj PDF`)
};

const fi_cover_letters_detail_export_pdf = /** @type {(inputs: Cover_Letters_Detail_Export_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vie PDF`)
};

const da_cover_letters_detail_export_pdf = /** @type {(inputs: Cover_Letters_Detail_Export_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksporter PDF`)
};

const sv_cover_letters_detail_export_pdf = /** @type {(inputs: Cover_Letters_Detail_Export_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportera PDF`)
};

/**
* | output |
* | --- |
* | "Export PDF" |
*
* @param {Cover_Letters_Detail_Export_PdfInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_detail_export_pdf = /** @type {((inputs?: Cover_Letters_Detail_Export_PdfInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Detail_Export_PdfInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_detail_export_pdf(inputs)
	if (locale === "fr") return fr_cover_letters_detail_export_pdf(inputs)
	if (locale === "es") return es_cover_letters_detail_export_pdf(inputs)
	if (locale === "it") return it_cover_letters_detail_export_pdf(inputs)
	if (locale === "nl") return nl_cover_letters_detail_export_pdf(inputs)
	if (locale === "pl") return pl_cover_letters_detail_export_pdf(inputs)
	if (locale === "fi") return fi_cover_letters_detail_export_pdf(inputs)
	if (locale === "da") return da_cover_letters_detail_export_pdf(inputs)
	if (locale === "sv") return sv_cover_letters_detail_export_pdf(inputs)
	return en_cover_letters_detail_export_pdf(inputs)
});